var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGas = function SvgGas(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M6.356 11.26c2.472-2.73 3.688-3.877 3.745-7.995a.2.2 0 0 1 .282-.18c4.706 2.224 5 6.461 4.112 8.176-.723 1.398.302 1.748.905 1.748 1.199 0 1.86-1.8 2.137-2.915.046-.186.3-.22.377-.045.656 1.492 1.891 5.064.328 7.33-1.809 2.622-4.07 3.933-8.14 3.496s-6.912-6.118-3.746-9.614Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M9.554 11.704c-.777.704-2.033 2.452-.846 3.814"
  })));
};
export default SvgGas;